
// Not sure why, but this is needed for typescript compiler to actually load the types defined there (it should be by default since we don't specify a types:[] array in the ts config)
// But somehow it's not \|/
/// <reference types="intercom-web" />

// Just a trick : we declare the Intercom constant (from the window)
// Other typescript can import it as a regular import to hide the trick / locate it only in one place
// If intercom is not present because of adblocks, the constant will resolve to null and other script checking on if(Intercom) will correctly safeguard againt null
// Exported as lowercase to align with the rest of the codebase convention
export const intercom: Intercom_.IntercomStatic = window.Intercom;